import { render } from "./TransactionItems.vue?vue&type=template&id=f357ef54&scoped=true"
import script from "./TransactionItems.vue?vue&type=script&lang=js"
export * from "./TransactionItems.vue?vue&type=script&lang=js"

import "./TransactionItems.vue?vue&type=style&index=0&id=f357ef54&scoped=true&lang=css"

import exportComponent from "/home/melvin/Workspace/Sjef.app/frontend/pos.sjef.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f357ef54"]])

export default __exports__